// React
import React from 'react';
import { useTranslation } from 'react-i18next';

// Libs
import { Table } from 'semantic-ui-react';

// Type
type LeadsNothingComponentProps = {
    colSpan: number;
};

/**
 * No leads available. Message spans over the all columns.
 *
 * @param LeadsNothingComponentProps
 * @returns React.ReactElement
 */
export default function LeadsNothingComponent(props: LeadsNothingComponentProps): React.ReactElement {
    const { t } = useTranslation();

    return (
        <Table.Body>
            <Table.Row>
                <Table.Cell colSpan={props.colSpan} textAlign="center" selectable={false}>
                    <div style={{ padding: '2rem' }}>{t('lead.list.messages.nothing')}</div>
                </Table.Cell>
            </Table.Row>
        </Table.Body>
    );
}
